import { Img, Heading, Text, Button } from "./..";
import React from "react";
import { Link } from "react-router-dom"; // Import the Link component from react-router-dom

export default function UserProfile2({
  userImage = "images/img_container_246x354.png",
  industryButtonText = "Industry",
  readingTimeText = "12 min read",
  title = "End to End Solution",
  descriptionText = "Our standardized platform is comprehensive and enables manufacturers to maximize efficiency, reduce costs, and ensure quality and compliance.",
  readMoreText = "Read More",
  blogPostId = 1, // Assuming each UserProfile2 component is associated with a specific blog post ID
  ...props
}) {
  return (
    <div
      {...props}
      className={`${props.className} flex flex-col w-full gap-8 border-color_style-02_primary_blue-blue500 border-[0.38px] border-solid rounded-[20px]`}
    >
      <Img
        src={userImage}
        alt="Image Container"
        className="h-[246px] w-full rounded-tl-[20px] rounded-tr-[20px] object-cover"
      />
      <div className="mx-6 mb-6 flex flex-col gap-[26px] self-stretch">
        <div className="flex flex-col gap-3.5">
          <div className="flex items-center justify-center">
            <Button color="amber_800_26" className="min-w-[124px] rounded-[16px] px-[22px] sm:px-5">
              {industryButtonText}
            </Button>
            <div className="flex flex-1 items-center gap-[11px] px-2.5">
              <div className="h-[4px] w-[4px] rounded-sm bg-amber-800_01" />
              <Text as="p" className="text-[18.03px] font-normal text-muted">
                {readingTimeText}
              </Text>
            </div>
          </div>
          <div className="flex flex-col items-start gap-2">
            <Link to={`/blog/${blogPostId}`}> {/* Link to the specific blog post page */}
              <Heading
                size="heading8xl"
                as="h4"
                className="text-[25.54px] font-bold text-color_style-01_neutrals-grey800"
              >
                {title}
              </Heading>
            </Link>
            <Text as="p" className="w-full text-[18.03px] font-normal leading-[23px] text-muted">
              {descriptionText}
            </Text>
          </div>
        </div>
        <div className="flex items-center gap-2.5">
          <Link to={`/blog/${blogPostId}`}> {/* Link to the specific blog post page */}
            <Heading size="text6xl" as="p" className="text-[19.53px] font-medium text-light_blue-a700">
              {readMoreText}
            </Heading>
          </Link>
          <Img src="images/img_vector_16_light_blue_a700.svg" alt="Read More Icon" className="h-[10px]" />
        </div>
      </div>
    </div>
  );
}
